"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastRecipe = void 0;
const utils_1 = require("../utils");
function lastRecipe({ forEach, resolver, filter }) {
    return function (predicate = utils_1.truth) {
        let result;
        return resolver(forEach.call(filter.call(this, predicate), (last) => (result = last)), () => result);
    };
}
exports.lastRecipe = lastRecipe;
